import logger from '@dialpad/logger';

export default logger('powerdialer');
